//

// ******************************************************************
// * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. *
// ******************************************************************
import { DiscoveryApi } from '../types/discovery';
import { FetchApi } from '../types/fetch';
import crossFetch from 'cross-fetch';
import { pluginId } from '../pluginId';
import * as parser from 'uri-template';

import { ConnectorAlterOffsetStatus } from '../models/ConnectorAlterOffsetStatus.model';
import { ConnectorDetails } from '../models/ConnectorDetails.model';
import { ConnectorsInner } from '../models/ConnectorsInner.model';

/**
 * Wraps the Response type to convey a type on the json call.
 *
 * @public
 */
export type TypedResponse<T> = Omit<Response, 'json'> & {
  json: () => Promise<T>;
};

/**
 * Options you can pass into a request for additional information.
 *
 * @public
 */
export interface RequestOptions {
  token?: string;
}

/**
 * no description
 */
export class DefaultApiClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi || { fetch: crossFetch };
  }

  /**
   * connector offset
   * @param name the name of the connector
   */
  public async getConfluentConnectorOffsetName(
    // @ts-ignore
    request: {
      path: {
        name: string;
      };
    },
    options?: RequestOptions,
  ): Promise<TypedResponse<ConnectorDetails>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/connector/offset/{name}`;

    const uri = parser.parse(uriTemplate).expand({
      name: request.path.name,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   * connector alter offset request status
   * @param name the name of the connector
   */
  public async getConfluentConnectorOffsetStatusName(
    // @ts-ignore
    request: {
      path: {
        name: string;
      };
    },
    options?: RequestOptions,
  ): Promise<TypedResponse<ConnectorAlterOffsetStatus>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/connector/offset/status/{name}`;

    const uri = parser.parse(uriTemplate).expand({
      name: request.path.name,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   * connectors
   */
  public async getConfluentConnectors(
    // @ts-ignore
    request: {},
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<ConnectorsInner>>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/connectors`;

    const uri = parser.parse(uriTemplate).expand({});

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   * endpoint to increment offset of connector
   * @param name the name of the connector
   */
  public async postConfluentConnectorOffsetAlterName(
    // @ts-ignore
    request: {
      path: {
        name: string;
      };
    },
    options?: RequestOptions,
  ): Promise<TypedResponse<void>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/connector/offset/alter/{name}`;

    const uri = parser.parse(uriTemplate).expand({
      name: request.path.name,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'POST',
    });
  }
}
